export const headersTransferenciasOrgInter = [
  { text: '', width: 1, key: 'offCanvas' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 15, key: 'id' },
  { text: 'Nº Contrato de Câmbio', width: 15, key: 'contratoCambio' },
  { text: 'Data Contrato', width: 10, key: 'dataContrato' },
  { text: 'Valor Transf. R$', width: 10, key: 'valorTransferido' },
  { text: 'Cotação R$/US$', width: 8, key: 'cotacaoDolar' },
  { text: 'Valor Dólares US$', width: 10, key: 'valorTotalDolares' },
];

export const valoresExibidosTransferenciasOrgInter: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  dataContrato: 'Data Contrato',
  contratoCambio: 'Contrato de Câmbio',
  valorTransferido: 'Valor Transferido R$',
  cotacaoDolar: 'Cotação do Dólar',
  valorTotalDolares: 'Total em US$',
  valorTotal: 'Valor Total R$',
  status: 'Status',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorValores: '',
};

export const fieldObjectTransferenciasOrgInter = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
